const formations = [
  {
    label: "Biotechnologies & Management",
    value: "Biotechnologie"
  },
  {
    label: "Énergie & Management", 
    value: "Energie"
  },
  {
    label: "Digital & Management",
    value: "Digital"
  },
  {
    label: "Informatique & Management",
    value: "Informatique"
  }
]

export default formations